// extracted by mini-css-extract-plugin
export default {"images":"IndianSpices_images__cOtBh"};